import BaseComponent from "../../../baseComponent.js";
import TextualWidget from "../../widgets/textual/textualWidget.jsx";

export default class Textual extends BaseComponent {
  constructor(props) {
    super(props);
  }

  render() {
    let style = {
      height: "100px",
      margin: "50px auto"
    };
    return (
      <div style={style} id="edit-textual">
        <TextualWidget model={this.props.model}
                       widget={this.props.model}
                       editMode={true}
                       togglePreloader={() => true}
                       components={this.props.components}/>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/add-widget/widgets/textual.jsx